

(function(){

    angular.module('tmx-app').controller('auditlogCtrl', ['$state', '$mdSidenav','tmxUtility','tmxResource','AuditlogService','menu',
   

        function AuditlogCtrl($state, $mdSidenav,tmxUtility,tmxResource,AuditlogService,menu){

            var auditvm=this;
            var exists;
            var copy;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            auditvm.EntityName = "AuditLog";
            auditvm.menu = menu;
            auditvm.formatDateTime=tmxUtility.formatDateTimeForCompany;
       
        
            auditvm.isFiltered=function(fieldName){
                var filtered = false;
                if(angular.isDefined(auditvm.filters)) {
                    auditvm.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName) {filtered = true;}
  
                    });
                }
                return filtered;
            }

            auditvm.success=function(promise){
                if(promise.read==true) {
                    auditvm.container.userGrid.dataSource.transport.read(promise);
                }
                else {
                    auditvm.container.userGrid.dataSource.read(); 
                }
                auditvm.toggleSearch(auditvm.nav);
            };

            auditvm.toggleSearch = function() {
                if (auditvm.searchSideNavActive) {
                    auditvm.searchSideNavActive = false;
                }
                else
                    auditvm.searchSideNavActive = true;
                auditvm.toggle('SearchSideNav');
            }
            auditvm.toggleExport = function() {
                if (auditvm.exportSideNavActive)
                    auditvm.exportSideNavActive = false;
                else
                    auditvm.exportSideNavActive = true;
                auditvm.toggle('ExportSideNav');
            }
            auditvm.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
            auditvm.toggle = function(navID) {
                if (navID != 'ExportSideNav' && auditvm.isOpen('ExportSideNav')) {
                    $mdSidenav('ExportSideNav')
                        .toggle()
                        .then(function () {
                        });
                }
                if (navID != 'SearchSideNav' && auditvm.isOpen('SearchSideNav')) {
                    $mdSidenav('SearchSideNav')
                        .toggle()
                        .then(function () {
                        });
                }
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {});
            };
            auditvm.search = function(navID) {
                let calls = [];
                for (var key in auditvm.searchData) {
                    if (auditvm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: auditvm.searchData[key]
                        });
                    }
                }
                auditvm.filt = {
                    filters: calls,
                    logic: "and"
                };
                auditvm.o.data.filter = auditvm.filt;

                auditvm.container.userGrid.dataSource.transport.read(auditvm.o);
        // userVM.searchData = {};
                auditvm.toggle(navID);
            };
            auditvm.clear = function(navID) {
        // userVM.searchData = {};
                auditvm.toggle(navID);
            };
      
            auditvm.clearSideNav = function() {
                auditvm.searchData = {};
            };
      ////////////////////////////////////////////////////
       //////////////////////CODE//////////////////////////
    
    //userVM.UsersService = UsersService;
            auditvm.cols = AuditlogService.gridColumn;
            auditvm.nav = "SearchSideNav";
            auditvm.schema = AuditlogService.schema;
            auditvm.gridData = new kendo.data.ObservableArray([]);
            auditvm.cloneColumn = angular.copy(AuditlogService.gridColumn);
            auditvm.clone = 0;
            auditvm.dataObj = {
                value: "empty"
            };
            auditvm.gridColumns = angular.copy(AuditlogService.columns);
    
            auditvm.gridColumns.push({
                title: "",
                width: "5%",
                template: "<md-button ng-click='AuditlogCtrl.showDetails(dataItem)' class='save-button' id='detail'>detail</md-button>"
            });
            auditvm.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            if(angular.isDefined(auditvm.searchClear) && auditvm.searchClear==false){
                                if(exists(auditvm.o)){
                                    copy(auditvm.o.data,["filter"],o.data);
                                }
                            }
                            auditvm.searchClear = false;
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    auditvm.searchClear = true;
                                    $state.searchClear=undefined;
                                }

                            }
                            else
                                o.data.firstPage = true;
                            auditvm.o = angular.copy(o);
                            if(auditvm.o.data.firstPage){
                                selected();
                            }
                            auditvm.filters = auditvm.o.data.filter;
                            AuditlogService.getByParams(o, true).then(function(response) {
                                parseResppnse(response.data);
                                o.success(response);
                                auditvm.recievedLov = true;
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort:  [{field: "TimeStamp", dir: "desc"}],
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "AuditLog.pdf"
                },
                excel: {

                    fileName: "AuditLog.xlsx"
                },
                sortable: true,
                scrollable: false,
                columns: auditvm.gridColumns
            };
    

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.TimeStamp= auditvm.formatDateTime(dataItem.TimeStamp);                  
                });                                
            }
   //////////////////////////////////////////////
            auditvm.bulk = [];
            auditvm.container = {};
            $state.data = {
                grid: auditvm.container
            };
            auditvm.searchSideNavActive = false;
            auditvm.exportSideNavActive = false;
            auditvm.filt = {};
//////////////////////////////////////////////////
            function selected() {
                var dataSource =  auditvm.container.userGrid.dataSource;
                if(angular.isDefined(auditvm.o) && angular.isDefined(dataSource) &&
        auditvm.o.data.firstPage && dataSource.page() != 1) {//implies data loaded into grid is just the firt page data
                    dataSource.page(1);
                }
            }
    
            var wnd;

            wnd = $("#details")
                .kendoWindow({
                    title: "Data",
                    modal: true,
                    visible: false,
                    resizable: true,
                    width: 400,
                    height:100,
       
                }).data("kendoWindow");
   

            auditvm.showDetails=function(dataitem) {
                tmxResource("AuditLog/GetDetailById/").getById(dataitem.LogId).then(function(response){                 
                    auditvm.parameter = response.data.Parameters;
                    wnd.content(auditvm.parameter);
                    wnd.center().open();
                });

            }

        }]);
   
}
)();

 